var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react');
var PullOutHandle = require('./PullOutHandle.jsx');
var Accessory = require('./Accessory.jsx');
var AccordionTab = dynamicRequire('AccordionTab.jsx');
var Mssg = dynamicRequire('Mssg.jsx');
var SVGIcon = dynamicRequire('SVGIcon.jsx');

class Accessories extends React.Component {

    render() {
        return <AccordionTab name="accessories" group='caseconfigurator'>
            <strong className="headline"><Mssg __key="nc_casefactory.accessory" /><SVGIcon identifier={'plus'}/><SVGIcon identifier={'minus'}/></strong>
            <div className="lr-casefactory-choices-part-picker part-picker">
                {this.getLabelNotch().length ? <Accessory basePath={this.props.basePath} case={this.props.case} accessory={this.getLabelNotch()}/> : ''}
                {this.getVentilationDish().length ? <Accessory basePath={this.props.basePath} case={this.props.case} accessory={this.getVentilationDish()}/> : ''}
                {this.getPullOutHandle().length ? <PullOutHandle basePath={this.props.basePath} case={this.props.case} accessory={this.getPullOutHandle()}/> : ''}
            </div>
        </AccordionTab>
    }

    getLabelNotch() {
        return this.props.possibleParts.filter((part)=> {
            return part.category == 'ACCESSORY_LABEL_NOTCH';
        })
    }
    getVentilationDish() {
        return this.props.possibleParts.filter((part)=> {
            return part.category == 'ACCESSORY_VENTILATION_DISH';
        })
    }
    getPullOutHandle() {
        return this.props.possibleParts.filter((part)=> {
            return part.category == 'ACCESSORY_PULLOUT_HANDLE';
        })
    }
}

Accessories.contextTypes = {
};


module.exports = Accessories;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Options/Accessories.jsx